import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import "./form-field.scss";

const FormField = ({ children, valid, className, hasMaxWidth, ...props }) => {
  const classes = classnames(
    "form-field",
    {
      "form-field--valid": valid,
      "form-field--invalid": valid != null && !valid,
      "form-field--max-width": hasMaxWidth,
    },
    className
  );
  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

FormField.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  valid: PropTypes.bool,
  className: PropTypes.string,
  hasMaxWidth: PropTypes.bool,
};

export default FormField;
